import { render, staticRenderFns } from "./VisionSimulator.vue?vue&type=template&id=8689ee86&scoped=true&"
import script from "./VisionSimulator.vue?vue&type=script&lang=js&"
export * from "./VisionSimulator.vue?vue&type=script&lang=js&"
import style0 from "./VisionSimulator.vue?vue&type=style&index=0&id=8689ee86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8689ee86",
  null
  
)

export default component.exports